module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    staticClass: "chapter",
    attrs: {
      "epub:type": "dedication",
      "id": "ded",
      "role": "doc-dedication"
    }
  }, [_c('p', {
    staticClass: "dedf"
  }, [_c('span', {
    staticClass: "page",
    attrs: {
      "aria-label": "v",
      "id": "pv",
      "role": "doc-pagebreak"
    }
  }), _vm._v("This anthology is dedicated to the memory of Carrie Fisher in all her guises: writer, mental health advocate, comedian, feminist activist, Princess Leia, and Space Mom.")]), _vm._v(" "), _c('hr', {
    staticClass: "sec-break"
  }), _vm._v(" "), _c('p', {
    staticClass: "sec"
  }, [_vm._v("✴♦✴")]), _vm._v(" "), _c('p', {
    staticClass: "ded"
  }, [_vm._v("It is also dedicated to the fans and community her presence inspired to keep fighting to flip off the world another day.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-58f78ce6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/wsu-midejewski-0006.vue
// module id = 69
// module chunks = 0